"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (digits) {
    return Math.pow(10, -digits);
};